module.exports = __webpack_public_path__ + "img/slide15-tronic-else.91b51210.png";